import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=1879c016&lang=pug&"
import script from "./banner.vue?vue&type=script&lang=js&"
export * from "./banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1879c016')) {
      api.createRecord('1879c016', component.options)
    } else {
      api.reload('1879c016', component.options)
    }
    module.hot.accept("./banner.vue?vue&type=template&id=1879c016&lang=pug&", function () {
      api.rerender('1879c016', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/banner/banner.vue"
export default component.exports